import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const IsFiscalized: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = dishForFullInfo?.isFiscalized;
	const inputValue = isChecked ? t('yes') : t('no');

	return (
		<FullInfoField
			label="isFiscalizedLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
